module.exports = __webpack_public_path__ + "95649025113b2625f120f402bfbf4e5d.woff";